import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 3h8a2 2 0 0 1 2 2v14.936a1 1 0 0 1-1.62.785L12 17.263l-4.38 3.458A1 1 0 0 1 6 19.936V5a2 2 0 0 1 2-2m7.707 5.707a1 1 0 0 0-1.414-1.414L11 10.586 9.707 9.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0z",
      clipRule: "evenodd"
    }
  )
);
var SvgBookmarkAddedFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var BookmarkAddedFilled_default = SvgBookmarkAddedFilled;

export { BookmarkAddedFilled_default as default };
